/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TrainerDashboardService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get trainer dashboard summary and customer coaching metrics
     * @returns any Trainer dashboard data
     * @throws ApiError
     */
    public getTrainerDashboard(): CancelablePromise<{
        summary: {
            totalCustomers: number;
            activeCustomers: number;
            unreviewedSessions: number;
            averageAdherence: number;
        };
        customers: Array<{
            id: string;
            name: string | null;
            email: string;
            lastActivityAt: string | null;
            unreviewedSessionCount: number;
            weeklyAdherence: number | null;
            assignedProgramCount: number;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/trainer/dashboard',
            errors: {
                401: `Unauthorized`,
                403: `Only trainers can access this endpoint`,
            },
        });
    }

}
